<div *ngIf="!!eventCardContainer && eventCardContainer.items.length > 0" class="event-card-scroll bg-overlay bg-position">
  <!-- BG overlay -->
  <div class="red-overlay"></div>

  <!-- Title -->
  <div class="container">
    <main class="main-content header">
      <h1 *ngIf="eventCardContainer.title?.text" class="event-card-scroll__title text-center text-lg-start display-4 m-0">
        {{ getFirstWord(eventCardContainer.title?.text) }} 
        <span *ngIf="getSecondWord(eventCardContainer.title?.text)" class="text-primary font-family-regular">
          {{ getSecondWord(eventCardContainer.title?.text) }}
        </span>
        {{ getRemainingWords(eventCardContainer.title?.text) }}
      </h1>
    </main>
  </div>

  <!-- Scrolling Event Cards -->
  <div class="container carousel-wrapper">
    <div class="main-content scroll-content">
      <div class="d-flex w-100">
        <swiper [config]="config">
          <ng-container *ngFor="let eventCard of thumbnailEventCardItems">
            <ng-template swiperSlide>
              <flo-thumbnail-event-card [eventCard]="eventCard" [geoBlockedIds]="geoBlockedIds" (eventClicked)="handleEventItemClicked($event)"></flo-thumbnail-event-card>
            </ng-template>
          </ng-container>
        </swiper>
      </div>
    </div>
  </div>

  <!-- More Upcoming Event List Accordian -->
  <div *ngIf="moreUpcomingEventItems" class="container event-list-container">
    <main class="main-content accordion">
      <h2 class="h2 event-list-title font-family-book text-100 m-0">More Upcoming Events</h2>
      <button class="accordion-icon-wrapper bg-primary rounded-circle border-0" (click)="isEventListExpanded = !isEventListExpanded">
        <span
          data-test="faq-chevrons"
          class="text-100 rotate svg-vertical-align-middle"
          [ngClass]="{ 'rotate-down': isEventListExpanded }"
          aria-hidden="true"
        >
          <flo-svg-icon [width]="30" icon="icon-chevron-down"></flo-svg-icon>
        </span>
      </button>
      <div
        class="event-list answer-container d-flex flex-column w-100 text-100 font-family-book"
        [ngClass]="{ show: isEventListExpanded, hide: !isEventListExpanded }"
        data-test="event-list"
      >

        <a *ngFor="let eventCard of moreUpcomingEventItems" class="event-list-item" (click)="handleEventItemClicked(eventCard)">
          <div class="event-list-item__detail">
            <div class="date">{{ eventCard.label1Parts?.startDateTime | date: 'MMM d' }}</div>
            <div class="time font-family-light">{{ eventCard.label1Parts?.startDateTime | date: 'shortTime' }}</div>
          </div>
          <div class="event-list-item__title">
            <div>{{ eventCard.title }}</div>
          </div>
          <div class="event-list-item__icon">
            <span
              data-test="faq-chevrons"
              class="rotate-svg-270 svg-vertical-align-middle"
              aria-hidden="true"
            >
              <flo-svg-icon [width]="30" icon="icon-chevron-down"></flo-svg-icon>
            </span>
          </div>
        </a>
        <div class="bottom-space"></div>
      </div>
    </main>
  </div>
</div>